module.exports = __webpack_public_path__ + "img/1 (26).21216643.png";